export const labelTypes = [
  {
    type: "Home",
  },
  {
    type: "Work",
  },
  {
    type: "Personal",
  },
  {
    type: "Exercise",
  },
  {
    type: "Chores",
  },
  {
    type: "Health",
  },
];
